import { useMutation } from "@tanstack/react-query";

import { API_URL } from "@/constants/envVariables";
import { fetchApi } from "@/helpers/fetchApi";
import { AppError, RecoveryTransaction } from "@/types";

export const useInitiateRecovery = () => {
  const mutation = useMutation<RecoveryTransaction, AppError, { receiverId: string; walletId: string }>(
    {
      mutationFn: ({ receiverId, walletId }) => {
        return fetchApi(`${API_URL}/receivers/${receiverId}/wallets/${walletId}/recovery`, {
          method: "POST",
        });
      },
    },
  );

  return {
    ...mutation,
    error: mutation.error as AppError,
  };
};
